import React from 'react';

export const handleChange = (setStateAction: React.Dispatch<React.SetStateAction<string>>) => {
  return (event: React.ChangeEvent<HTMLInputElement>): void => {
    setStateAction(event.target.value);
  };
};
